import { DashboardLogTypeInput } from '@mildang/graphql-artifact';
import { ExternalActionData, XApiActionData, XApiActionType } from './Action';
import { LRS_X_API_EVENTS } from '@ui/utils/ActivityManager/constants';
import Record from '@ui/components/user/patterns/InitStudentUtil/Record/Record';

export type ExtractType<T> = T extends { type: infer U } ? U : never;

export type StudyEventType = 'STUDY_TIME_SPENT' | ExtractType<ExternalActionData>;

export type StudyEventContext = {
  studyModuleInstanceId?: string;
  studyUnitInstanceId?: string;
  studyActivityInstanceId?: string;
};

export type StudyEventRequestSessionInput = DashboardLogTypeInput & {
  view?: any;
};
export type StudyEventRequestInput = {
  eventId: string;
  eventType: StudyEventType;
  eventPublishedAt: string;
  sessionId: string;
  viewId: string;
  userId?: string;
  parentEventId?: string;
  studyModuleInstanceId?: string;
  studyUnitInstanceId?: string;
  studyActivityInstanceId?: string;
  duration?: string | number;
};

export type StudyEventAndSessionRequestInput =
  | StudyEventRequestInput
  | StudyEventRequestSessionInput
  | XApiActionData;

export function isDashboardLogTypeInput<T extends StudyEventAndSessionRequestInput>(
  input: T,
): input is T & StudyEventRequestSessionInput {
  return (input as StudyEventRequestSessionInput).type !== undefined;
}

export function isXApiActionData(input: any): input is XApiActionData {
  return input && typeof input === 'object' && LRS_X_API_EVENTS.includes(input.type);
}

export interface SendDeviceInput {
  id: string;
  ua: string;
  type?: string;
  os?: string;
  browser?: string;
}

export interface StudyEventLogInput {
  studyEventLogs: StudyEventAndSessionRequestInput[];
  device: SendDeviceInput;
}

export interface SaveBulkStudyEventLogResponseDto {
  success: boolean;
}

export type LearningRecordStoreDataCategory =
  | 'MEDIA'
  | 'ASSESSMENT'
  | 'ASSIGNMENT_GAVE'
  | 'ASSIGNMENT_FINISHED'
  | 'NAVIGATION'
  | 'QUERY'
  | 'ANNOTATION'
  | 'TEACHING';

export const LRS_DATA_CATEGORIES: Record<XApiActionType, LearningRecordStoreDataCategory> = {
  PLAYED_MEDIA: 'MEDIA',
  SUBMITTED_ASSESSMENT: 'ASSESSMENT',
  GAVE_ASSIGNMENT: 'ASSIGNMENT_GAVE',
  FINISHED_ASSIGNMENT: 'ASSIGNMENT_FINISHED',
  VIEWED_IMAGE: 'NAVIGATION',
  READ_DOCUMENT: 'NAVIGATION',
  DID_PRACTICE: 'NAVIGATION',
  LEARNED_ETC_CONTENT: 'NAVIGATION',
  ASKED_QUESTION: 'QUERY',
  PARTICIPATED_SOCIAL_LEARNING: 'NAVIGATION',
  REORGANIZED_CLASS: 'TEACHING',
};
